import { render } from "./HeaderLayout.vue?vue&type=template&id=0a184fb3"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/classic/HeaderLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a184fb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a184fb3', __exports__)) {
    api.reload('0a184fb3', __exports__)
  }
  
  module.hot.accept("./HeaderLayout.vue?vue&type=template&id=0a184fb3", () => {
    api.rerender('0a184fb3', render)
  })

}


export default __exports__